// Import states.
import {
	PossiblePerilsState
} from './PossiblePerilsState';
// Import api models.
import {
	PossibleBuildingUse,
	PossibleConstructionType,
	PossibleFoundationType,
	PossibleOccupancyType,
	PossibleParkingType,
} from '@app/models/api';

interface BroadLineOfBusinessState {
	arePossibleBuildingUsesLoaded: boolean;
	arePossibleConstructionTypesLoaded: boolean;
	arePossibleFoundationTypesLoaded: boolean;
	arePossibleOccupancyTypesLoaded: boolean;
	arePossibleParkingTypesLoaded: boolean;
	arePossiblePerilsLoaded: boolean;
	possibleBuildingUses: PossibleBuildingUse[];
	possibleConstructionTypes: PossibleConstructionType[];
	possibleFoundationTypes: PossibleFoundationType[];
	possibleOccupancyTypes: PossibleOccupancyType[];
	possibleParkingTypes: PossibleParkingType[];
	possiblePerils: { [stateCode: string]: PossiblePerilsState };
};


const getInitialState = (): BroadLineOfBusinessState => {
	return {
		arePossibleBuildingUsesLoaded: false,
		arePossibleConstructionTypesLoaded: false,
		arePossibleFoundationTypesLoaded: false,
		arePossibleOccupancyTypesLoaded: false,
		arePossibleParkingTypesLoaded: false,
		arePossiblePerilsLoaded: false,
		possibleBuildingUses: [],
		possibleConstructionTypes: [],
		possibleFoundationTypes: [],
		possibleOccupancyTypes: [],
		possibleParkingTypes: [],
		possiblePerils: {},
	};
};

export { getInitialState, BroadLineOfBusinessState };